import { Route, Routes } from '@angular/router';
import { ENGLISH, pathInLang } from './culture.config';

/**
 * The app's routes under every other language's prefix (Multilang_Culture_Spec.md 5.3): { path: 'ar', children: <the same
 * tree> } for each, ahead of the English tree, so /ar/products/details/x is the product page in Arabic and /ar the home
 * page. Each copied route carries data.lang, which a lazy module's own routes inherit through their componentless parent;
 * an absolute redirect stays in the language (/about-us becomes /ar/about-us). The English tree is left exactly as it is.
 */
export function withLanguagePrefixes(routes: Routes, languages: readonly string[]): Routes {
    const others = (languages || []).filter(lang => lang && lang !== ENGLISH);
    const prefixed: Routes = others.map(lang => ({
        path: lang,
        data: { lang },
        children: inLanguage(routes, lang, languages),
    }));
    return [...prefixed, ...routes];
}

function inLanguage(routes: Routes, lang: string, languages: readonly string[]): Routes {
    return routes.map(route => {
        const copy: Route = { ...route, data: { ...(route.data || {}), lang } };
        if (route.children) {
            copy.children = inLanguage(route.children, lang, languages);
        }
        if (typeof route.redirectTo === 'string' && route.redirectTo[0] === '/') {
            copy.redirectTo = pathInLang(route.redirectTo, lang, languages);
        }
        return copy;
    });
}
